import { BrandsFilterVO } from '@/apis/s/s.interface';
import { SearchBarType } from '@/app/s-for-addon/utils';
import _ from 'lodash';
export enum SortType {
  sort_default = 'sort_default',
  sort_dredisprice_asc = 'sort_dredisprice_asc',
  sort_dredisprice_desc = 'sort_dredisprice_desc',
}

export type Props = {
  searchParams: {
    k?: string;
    sortType?: SortType;
    page?: string;
    type?: SearchBarType;
    /** 关键词搜索事件类型: 0-用户手动输入, 1-sug词跳转, 2-热词跳转, 3-历史搜索词, 4-底纹搜索 */
    keywordsEventType?: string;
    [key: string]: string | undefined | string[];
    channelPage?: string[];
  };
};

// merge: true表示newParams里的key要和searchParams合并，false表示newParams覆盖searchParams
export const buildSearchUrl = (searchParams: any, baseUrl = '/s') => {
  // let paramsObject = {};
  // if (merge) {
  //   for (const key in newParams) {
  //     if (searchParams[key] === undefined) {
  //       continue;
  //     } else {
  //       const originParams = (searchParams[key] || "").split("--").filter((v) => v);
  //       if (originParams.includes(newParams[key] as string)) {
  //         newParams[key] = _.pull(originParams, newParams[key]).join("--");
  //       } else {
  //         newParams[key] = _.uniq([...originParams, newParams[key]]).join("--");
  //       }
  //     }
  //   }
  // }
  // paramsObject = Object.assign({}, searchParams, newParams);
  // paramsObject = _.omitBy(paramsObject, (v) => v === undefined || v === "");

  // 这里必须要给url上加一个额外的参数，否则进入A链接，再通过history API修改url后，再点击A链接，则不会生效，因为next会认为url没有发生变化，导致页面不刷新
  Object.assign(searchParams, { _: Date.now() });
  return `${baseUrl}?${new URLSearchParams(
    _.omitBy(searchParams, (v) => v === undefined || v === '' || v === null),
  ).toString()}`;
};

/**
 * 将数值格式化为带千位分隔符和两位小数的字符串，不含货币符号。
 *
 * @param {number} n - 要格式化的数字。
 * @returns {string} 格式化后的字符串，包含千位分隔符（例如："11,234"）。
 *
 * @example
 * formatInteger(1234);   // "1,234"
 * formatInteger(1234567);  // "1,234,567"
 */
export function formatInteger(n: number): string {
  return new Intl.NumberFormat('en-GB', {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(n);
}

export function lockPage() {
  if (document.getElementById('main-container')) {
    (document.getElementById('main-container') as HTMLElement).style.overflow = 'hidden';
  }
}

export function resetLockPage() {
  if (document.getElementById('main-container')) {
    (document.getElementById('main-container') as HTMLElement).style.overflow = 'scroll';
  }
}

// 获取价格初始化的值
export const parsePriceRange = (
  priceRange: string,
  priceCollection: { min: string; max: string },
): { min: string; max: string } => {
  const result = {
    min: '',
    max: '',
  };
  const maxMatches = priceRange.match(/L(\d+)/);

  if (maxMatches) {
    // 兼容输入价格合法性
    result.max =
      // @ts-ignore
      Number(priceCollection?.max || '0') > maxMatches[1] ? maxMatches[1] : priceCollection.max;
  }

  const minMatches = priceRange.match(/M(\d+)/);

  if (minMatches) {
    // 兼容输入价格合法性
    result.min =
      // @ts-ignore
      Number(priceCollection?.min || '0') < minMatches[1] ? minMatches[1] : priceCollection.min;
  }

  return result;
};

// 获取有效的brandId
export const getValidBrandIds = (filterByBrandIdsStr: string, brands: BrandsFilterVO[]) => {
  const filterByBrandIds =
    filterByBrandIdsStr
      ?.split('-')
      ?.filter((v) => v.trim())
      ?.map((v) => v.split('M')[1]) ?? [];
  return (brands || [])
    .filter((brand) => filterByBrandIds.includes(brand.value))
    .map((b) => b.value);
};

// 获取有效的扩展属性
// @ts-ignore
export const getValidExtAttrs = (filterByExpandNameStr: string, extAttrCollection) => {
  const filterByExpandName = {} as Record<string, string[]>;
  filterByExpandNameStr
    .split('**')
    ?.filter((v) => v.trim())
    ?.forEach((v) => {
      const item = v.split('::');
      console.log('--bh--选中的扩展属性项和属性值---', item);
      if (item.length === 2 && /^\d+$/.test(item[1])) {
        const groupIdIndex = (extAttrCollection || []).findIndex(
          // @ts-ignore
          (extAttr) => extAttr.id === item[1],
        );
        console.log('--bh--选中的属性项id---', groupIdIndex); // 属性组id有效
        if (groupIdIndex >= 0) {
          // 找出属性值有效的id
          const saleAttrs = item[0].split('--').filter((v) => v.trim() && /^\d+$/.test(v));
          console.log('--bh--选中的属性值id---', saleAttrs);
          filterByExpandName[item[1]] = extAttrCollection[groupIdIndex].saleAttrs
            // @ts-ignore:next-line
            .filter((s) => saleAttrs.map((v) => ~~v).includes(~~s.id))
            // @ts-ignore:next-line
            .map((v) => v.id);
        }
      }
    });

  return filterByExpandName;
};
